import { ChildModel, ModelBase } from 'store/model-base';
import { SsmEstimatedMessage } from './ssm-estimated-message';
import { CmsBillingStatement } from 'store/cms/models';
import { PaymentState, StatementRouteParam, StatementSummaryId } from 'my-account/constants';
import { Util } from 'services/util';
import { Warnings } from './warnings';

export class SsmHistorical extends ModelBase {
    public static storeName: string = 'ssmHistorical';
    public warnings: Warnings[];
    public message: SsmEstimatedMessage;
    public isEstimated: boolean;
    public isPaid: boolean;
    public isPastDue: boolean;
    public isNextPayment: boolean;
    public dateRange: string;
    public localeAutoPayDate: string;
   
    public static create<T extends ModelBase>(response: ApiResponse, id?: string): T {
        if (!response.id) {
            response.id = {
                value: '',
                key: id
            };
        } else {
            response.id.key = id;
        }

        response.isEstimated = response.message.state === PaymentState.ESTIMATED;
        response.isPaid = response.message.state === PaymentState.PAID;
        response.isPastDue = response.message.state === PaymentState.PAST_DUE;
        response.isNextPayment = response.message.state === PaymentState.PENDING;

        response.localeAutoPayDate = Util.dateFormat(response.message.autoPayDate, 'MMM dd');
        response.dateRange = SsmHistorical.getDateRange(response.message);

        return super.create<T>(response);
    }

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'message',
            model: SsmEstimatedMessage
        }];
    }

    public static getDateRange(data: ApiResponse): string {
        const startDate: string = Util.dateFormat(data.cycleStartDate, 'MMM dd');
        const endDate: string = Util.dateFormat(data.cycleEndDate, 'MMM dd');

        return `${startDate} - ${endDate}`;
    }

    public buildSummaryCms(cmsData: CmsBillingStatement, paymentState: StatementRouteParam): CmsStatementSummary {
        let summaryContentId: string = '';
        
        if (this.isEstimated) {
            summaryContentId = StatementSummaryId.ESTIMATED;
        } else if (this.isPaid) {
            summaryContentId = StatementSummaryId.PAID;
        } else if (this.isNextPayment && paymentState === StatementRouteParam.PENDING) {
            summaryContentId = StatementSummaryId.NEXT;
        } else if (this.isNextPayment && paymentState === StatementRouteParam.PENDING_WITH_CREDIT) {
            summaryContentId = StatementSummaryId.NEXT_WITH_CREDIT;
        } else if (this.isPastDue) {
            summaryContentId = StatementSummaryId.PAST_DUE;
        }

        return cmsData.summaryContents.find((each: CmsStatementSummary) => each.id === summaryContentId);
    }

    public getStatementHeading(content: CmsStatementSummary): string {
        return content.pageTitle.replace('[DATE_RANGE]', this.dateRange);
    }

}
